import React, { useState } from 'react';
import { useDocument } from '../../utils/DocumentContext';
import DataTable from '../DataTable';
import WindowProducts from '../Windows/WindowProducts';
import { saveProcessedDocument } from '../../utils/api';

// CSS анимация для вращения
const spinKeyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Добавляем стили в head, если их еще нет
if (typeof window !== 'undefined' && !window.document.querySelector('#spin-animation-styles')) {
  const style = window.document.createElement('style');
  style.id = 'spin-animation-styles';
  style.textContent = spinKeyframes;
  window.document.head.appendChild(style);
}

export default function SelectedDocumentSection() {
  const [showProductsWindow, setShowProductsWindow] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const {
    selectedDocument,
    documentPositions,
    hasSelectedDocument,
    getDocumentStats,
    documentType,
    clearDocument
  } = useDocument();
  // Функції для роботи з вікном товарів
  const handleOpenProducts = () => {    console.log('Відкриваємо документ:', selectedDocument);
    console.log('Позиції документа:', documentPositions);
    if (selectedDocument && documentPositions) {
      setShowProductsWindow(true);
    } else {
      console.warn('Документ або позиції не завантажені');
    }
  };

  const handleCloseProducts = () => {
    setShowProductsWindow(false);
  };
  const handleOpenPrint = (printData = [], documentData = null, positions = []) => {
    console.log('handleOpenPrint викликано з SelectedDocumentSection:', { printData, documentData, positions });
    // Здесь можно добавить логику открытия окна печати, если понадобится
  };

  // Функция обработки документа (как в WindowProducts.jsx)
  const handleProcessDocument = async () => {
    try {
      setIsProcessing(true);
        // Подготавливаем данные документа для отправки (оптимизированный формат)
      const documentToProcess = {
        // Основные поля документа (формат 1С)
        ДокументНомер: selectedDocument?.ДокументНомер || selectedDocument?.documentNumber || selectedDocument?.filename || selectedDocument?.id,
        ДокументДата: selectedDocument?.ДокументДата || selectedDocument?.created || new Date().toISOString(),        ДокументВид: selectedDocument?.ДокументВид || selectedDocument?.documentType || documentType || 'Не вказано',
        ДокументСтатус: 'Оброблено',
        ДатаОбработки: new Date().toISOString(),
        
        // Позиции документа (единый формат для 1С и API)
        Позиции: documentPositions.map(pos => ({
          Код: pos.Код || pos.article || '',
          Наименование: pos.Наименование || pos.name || '',
          Штрихкод: pos.Штрихкод || pos.barcode || '',
          КоличествоПлан: Number(pos.КоличествоПлан || pos.plan || 0),
          КоличествоФакт: Number(pos.КоличествоФакт || pos.fact || 0),
          КоличествоРезерв: Number(pos.КоличествоРезерв || pos.reserve || 0),
          Категория: pos.Категория || pos.category || '',
          Подкатегория: pos.Подкатегория || pos.subcategory || '',
          ТорговаяМарка: pos.ТорговаяМарка || pos.brand || '',
          Склад: pos.Склад || pos.warehouse || '',
          СтатусПозиции: pos.СтатусПозиции || pos.status || ''
        }))
      };

      console.log('Обробляємо документ:', documentToProcess);

      const result = await saveProcessedDocument(documentToProcess);
        if (result.success) {        alert(`Документ успішно оброблено!\nЗбережено як: ${result.fileName}`);
        console.log('Документ оброблено:', result.fileName);
        
        // Очищуємо вибраний документ після успішної фіксації
        clearDocument();
      } else {        throw new Error(result.error || 'Невідома помилка при обробці');
      }
    } catch (error) {
      console.error('Помилка обробки документа:', error);
      alert(`Ошибка при обработке документа:\n${error.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  if (!hasSelectedDocument) {
    return (
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        padding: '16px',
        boxSizing: 'border-box'
      }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '16px',
            padding: '8px 12px',
            background: 'linear-gradient(135deg, #fff3e0 0%, #ff9800 100%)',
            border: '1px solid #ff9800',
            borderRadius: '6px',
            boxShadow: '0 1px 3px rgba(255, 152, 0, 0.2)',
            flexShrink: 0
          }}
        >
          <span style={{ fontSize: '20px', marginRight: '8px' }}>📄</span>
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: '600',
                color: '#e65100'
              }}
            >
              Selected Document
            </h2>
          </div>
        </div>

        <div style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          background: '#f9f9f9',
          borderRadius: '8px',
          border: '2px dashed #ccc',
          padding: '32px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '64px', marginBottom: '16px', opacity: 0.5 }}>📄</div>          <h3 style={{ margin: '0 0 8px 0', color: '#666' }}>Документ не обрано</h3>
          <p style={{ margin: 0, color: '#999', fontSize: '14px' }}>
            Перейдіть на вкладку "Data Packets" і оберіть документ для роботи
          </p>
        </div>
      </div>
    );
  }

  const stats = getDocumentStats();  // Подготавливаем данные для таблицы
  const tableData = documentPositions.map((pos, index) => ({
    id: index + 1,
    article: pos.article || pos.Код || '',
    name: pos.name || pos.Наименование || '',
    barcode: pos.barcode || pos.Штрихкод || '',
    plan: Number(pos.plan || pos.КоличествоПлан || 0),
    fact: Number(pos.fact || pos.КоличествоФакт || 0),
    difference: Number(pos.fact || pos.КоличествоФакт || 0) - Number(pos.plan || pos.КоличествоПлан || 0)
  }));
  // Определяем колонки для таблицы
  const columns = [
    {
      key: 'article',
      title: 'Код',
      width: '120px',
      sortable: true
    },
    {
      key: 'name',
      title: 'Наименование',
      width: 'auto',
      sortable: true
    },
    {
      key: 'barcode',
      title: 'Штрихкод',
      width: '140px',
      sortable: true
    },
    {
      key: 'plan',
      title: 'План',
      width: '80px',
      sortable: true,
      textAlign: 'right',
      render: (value) => {
        const num = Number(value || 0);
        const str = num.toString();
        const dec = str.includes('.') ? str.split('.')[1] : '';
        const formatted = dec.length > 3 ? num.toFixed(3) : str;
        return <span style={{ fontWeight: 500 }}>{formatted}</span>;
      }
    },
    {
      key: 'fact',
      title: 'Факт',
      width: '80px',
      sortable: true,
      textAlign: 'right',
      render: (value) => {
        const num = Number(value || 0);
        const str = num.toString();
        const dec = str.includes('.') ? str.split('.')[1] : '';
        const formatted = dec.length > 3 ? num.toFixed(3) : str;
        return <span style={{
          fontWeight: 500,
          color: value > 0 ? '#2e7d32' : '#666'
        }}>{formatted}</span>;
      }
    },
    {
      key: 'difference',
      title: 'Разница',
      width: '90px',
      sortable: true,
      textAlign: 'right',
      render: (value, row) => {
        const diff = Number(value || 0);
        const fact = Number(row.fact || 0);
        const str = diff.toString();
        const dec = str.includes('.') ? str.split('.')[1] : '';
        const formatted = dec.length > 3 ? diff.toFixed(3) : str;
        
        let backgroundColor = 'transparent';
        let color = '#666';
        
        if (diff === 0) {
          backgroundColor = '#c8e6c9'; // Зеленый фон
          color = '#2e7d32';
        } else if (fact === 0) {
          backgroundColor = 'white'; // Белый фон
          color = '#666';
        } else if (diff !== 0) {
          backgroundColor = '#f8bbd9'; // Мадиновый фон
          color = '#ad1457';
        }
        
        return (
          <span style={{
            fontWeight: 500,
            color: color,
            backgroundColor: backgroundColor,
            padding: '2px 4px',
            borderRadius: '3px',
            display: 'inline-block',
            minWidth: '100%',
            textAlign: 'center'
          }}>
            {formatted}
          </span>
        );
      }
    }
  ];
  const totalPlan = tableData.reduce((sum, item) => sum + item.plan, 0);
  const totalFact = tableData.reduce((sum, item) => sum + item.fact, 0);
  const totalDifference = totalFact - totalPlan;

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      padding: window.innerWidth < 768 ? '8px 0' : '16px',
      boxSizing: 'border-box'
    }}>
      {/* Шапка секции */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: window.innerWidth < 768 ? '8px' : '16px',
          margin: window.innerWidth < 768 ? '0 8px 8px 8px' : '0 0 16px 0',
          padding: window.innerWidth < 768 ? '8px' : '12px',
          background: 'linear-gradient(135deg, #fff3e0 0%, #ff9800 100%)',
          border: window.innerWidth < 768 ? 'none' : '1px solid #ff9800',
          borderRadius: window.innerWidth < 768 ? '0' : '8px',
          boxShadow: window.innerWidth < 768 ? 'none' : '0 2px 6px rgba(255, 152, 0, 0.2)',
          flexShrink: 0
        }}
      >        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: '32px', marginRight: '12px' }}>📄</span>
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#e65100'
                }}
              >
                Selected Document
              </h2>              <div style={{ fontSize: '12px', color: '#bf360c', marginTop: '2px', lineHeight: '1.3' }}>
                <div>📑 {documentType || selectedDocument.documentType || 'Не вказано'} № {selectedDocument.filename || selectedDocument.id} від {selectedDocument.created ? new Date(selectedDocument.created).toLocaleString("uk-UA") : (selectedDocument.data?.ДокументДата ? new Date(selectedDocument.data.ДокументДата).toLocaleString("uk-UA") : 'Дата не вказана')}
                  {selectedDocument.isProcessed && (
                    <span style={{ 
                      marginLeft: '8px', 
                      padding: '2px 6px', 
                      backgroundColor: '#4caf50', 
                      color: 'white', 
                      borderRadius: '4px', 
                      fontSize: '10px',
                      fontWeight: 'bold'
                    }}>
                      ОБРОБЛЕНО
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Панели статистики */}
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <div style={{
            padding: '4px 8px',
            background: 'rgba(255,255,255,0.8)',
            borderRadius: '4px',
            textAlign: 'center',
            minWidth: '50px'
          }}>
            <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>{stats.total}</div>
            <div style={{ fontSize: '10px', color: '#666' }}>Всего</div>
          </div>
          <div style={{
            padding: '4px 8px',
            background: 'rgba(232,244,253,0.9)',
            borderRadius: '4px',
            textAlign: 'center',
            minWidth: '50px'
          }}>
            <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>{stats.processed}</div>
            <div style={{ fontSize: '10px', color: '#666' }}>Обраб.</div>
          </div>
          <div style={{
            padding: '4px 8px',
            background: 'rgba(232,245,232,0.9)',
            borderRadius: '4px',
            textAlign: 'center',
            minWidth: '50px'
          }}>
            <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>{stats.completed}</div>
            <div style={{ fontSize: '10px', color: '#666' }}>Готово</div>
          </div>
          <div style={{
            padding: '4px 8px',
            background: 'rgba(255,243,205,0.9)',
            borderRadius: '4px',
            textAlign: 'center',
            minWidth: '50px'
          }}>
            <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>{stats.remaining}</div>
            <div style={{ fontSize: '10px', color: '#666' }}>Остал.</div>
          </div>
        </div>
      </div>

      {/* Информация о документе (краткая) */}
      <div style={{
        marginBottom: '12px',
        padding: '8px 12px',
        background: '#fff',
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
        fontSize: '12px',
        color: '#666'
      }}>        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
            <span>📅 Создан: {new Date(selectedDocument.created).toLocaleDateString("ru-RU")}</span>
            <span>📏 Размер: {(selectedDocument.size / 1024).toFixed(1)} КБ</span>            <span>📊 Позиций: {tableData.length}</span>
            <span>📈 План: {totalPlan.toFixed(totalPlan % 1 === 0 ? 0 : 2)}</span>
            <span>✅ Факт: {totalFact.toFixed(totalFact % 1 === 0 ? 0 : 2)}</span>
            <span style={{
              color: totalDifference === 0 ? '#2e7d32' : (totalDifference > 0 ? '#ad1457' : '#f57c00')
            }}>
              📊 Разница: {totalDifference.toFixed(totalDifference % 1 === 0 ? 0 : 2)}
            </span>
          </div>
            {/* Кнопки действий */}
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {/* Аккуратная кнопка-пиктограмма открытия документа */}
            <button
              onClick={handleOpenProducts}
              style={{
                width: '32px',
                height: '32px',
                background: 'linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                cursor: 'pointer',
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 6px rgba(156, 39, 176, 0.25)',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                flexShrink: 0
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.1)';
                e.target.style.boxShadow = '0 4px 12px rgba(156, 39, 176, 0.4)';
                e.target.style.background = 'linear-gradient(135deg, #ab47bc 0%, #8e24aa 100%)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 2px 6px rgba(156, 39, 176, 0.25)';
                e.target.style.background = 'linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%)';
              }}
              title={`Открыть документ "${selectedDocument.filename || selectedDocument.id}" в отдельном окне`}
            >
              📦            </button>            {/* Кнопка фиксации документа - всегда доступна */}
            <button
              onClick={handleProcessDocument}
              disabled={isProcessing}
                style={{
                  width: '32px',
                  height: '32px',
                  background: isProcessing ? 
                    'linear-gradient(135deg, #a5d6a7 0%, #81c784 100%)' : 
                    'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  cursor: isProcessing ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: isProcessing ? 
                    '0 2px 6px rgba(76, 175, 80, 0.15)' : 
                    '0 2px 6px rgba(76, 175, 80, 0.25)',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  flexShrink: 0,
                  opacity: isProcessing ? 0.7 : 1
                }}
                onMouseEnter={(e) => {
                  if (!isProcessing) {
                    e.target.style.transform = 'scale(1.1)';
                    e.target.style.boxShadow = '0 4px 12px rgba(76, 175, 80, 0.4)';
                    e.target.style.background = 'linear-gradient(135deg, #66bb6a 0%, #43a047 100%)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isProcessing) {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 2px 6px rgba(76, 175, 80, 0.25)';
                    e.target.style.background = 'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)';
                  }
                }}
                title={isProcessing ? 'Обрабатывается...' : 'Отметить документ как обработанный'}
              >
                {isProcessing ? (
                  <span style={{ 
                    display: 'inline-block',
                    animation: 'spin 1s linear infinite',
                    fontSize: '12px'
                  }}>⏳</span>
                ) : (
                  '✅'                )}
              </button>
          </div>
        </div>
      </div>

      {/* Таблица позиций */}
      <div style={{
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {tableData.length === 0 ? (
          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            color: '#666',
            background: '#f9f9f9',
            borderRadius: '8px',
            border: '2px dashed #ccc',
            padding: '32px'
          }}>            <div style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }}>
              📦
            </div>
            <h3 style={{ margin: '0 0 8px 0' }}>
              Нет позиций
            </h3>
            <p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}>
              В выбранном документе отсутствуют позиции товаров
            </p>
          </div>        ) : (
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            overflow: 'hidden'
          }}>
            <DataTable
              data={tableData}
              columns={columns}
              options={{
                showCheckboxes: false,
                showRowNumbers: true,
                striped: true,
                bordered: true, // Включаем рамку таблицы
                hoverable: true,
                sortable: true,
                filterable: true, // Включаем встроенную фильтрацию DataTable
                emptyMessage: 'Нет товаров для отображения'
              }}
              style={{
                flex: 1,
                border: '1px solid #e0e0e0',
                borderRadius: '6px',
                overflow: 'hidden'
              }}
            />
          </div>
        )}
      </div>      {/* Окно товаров */}
      {showProductsWindow && selectedDocument && (
        <WindowProducts
          isOpen={showProductsWindow}
          document={{
            ...selectedDocument,
            ДокументНомер: selectedDocument.filename || selectedDocument.id,
            ДокументВид: documentType || selectedDocument.documentType || 'Не указан',
            ДокументДата: selectedDocument.created || selectedDocument.ДокументДата
          }}
          positions={documentPositions.map(pos => {
            // Если документ обработан, используем обработанные данные
            if (selectedDocument.isProcessed) {
              return {
                Код: pos.Код || pos.article || '',
                Наименование: pos.Наименование || pos.name || '',
                КоличествоПлан: Number(pos.КоличествоПлан || pos.plan || 0),
                КоличествоФакт: Number(pos.КоличествоФакт || pos.fact || 0),
                Штрихкод: pos.Штрихкод || pos.barcode || '',
                КоличествоРезерв: Number(pos.КоличествоРезерв || pos.reserve || 0),
                Категория: pos.Категория || pos.category || '',
                Подкатегория: pos.Подкатегория || pos.subcategory || '',
                ТорговаяМарка: pos.ТорговаяМарка || pos.brand || '',
                Склад: pos.Склад || pos.warehouse || '',
                СтатусПозиции: pos.СтатусПозиции || pos.status || '',
                // Дублируем поля для совместимости
                article: pos.Код || pos.article || '',
                name: pos.Наименование || pos.name || '',
                plan: Number(pos.КоличествоПлан || pos.plan || 0),
                fact: Number(pos.КоличествоФакт || pos.fact || 0),
                barcode: pos.Штрихкод || pos.barcode || '',
                reserve: Number(pos.КоличествоРезерв || pos.reserve || 0),
                category: pos.Категория || pos.category || '',
                subcategory: pos.Подкатегория || pos.subcategory || '',
                brand: pos.ТорговаяМарка || pos.brand || '',
                warehouse: pos.Склад || pos.warehouse || '',
                status: pos.СтатусПозиции || pos.status || ''
              };
            } else {
              // Если документ не обработан, используем исходные данные
              return {
                Код: pos.article || pos.Код || '',
                Наименование: pos.name || pos.Наименование || '',
                КоличествоПлан: Number(pos.plan || pos.КоличествоПлан || 0),
                КоличествоФакт: Number(pos.fact || pos.КоличествоФакт || 0),
                Штрихкод: pos.barcode || pos.Штрихкод || '',
                article: pos.article || pos.Код || '',
                name: pos.name || pos.Наименование || '',
                plan: Number(pos.plan || pos.КоличествоПлан || 0),
                fact: Number(pos.fact || pos.КоличествоФакт || 0),
                barcode: pos.barcode || pos.Штрихкод || ''
              };
            }
          })}
          onClose={handleCloseProducts}
          onOpenPrint={handleOpenPrint}
        />
      )}
    </div>
  );
}
